import Vue from 'vue'
import VueRouter from 'vue-router'

# Views
Order = () => import('@/views/Order.vue')
Kiosk = () => import('@/views/Kiosk.vue')
Start = () => import('@/views/Start.vue')
Address = () => import('@/views/Address.vue')
Closed = () => import('@/views/Closed.vue')
Register = () => import('@/views/Register.vue')
Menu = () => import('@/views/Menu.vue')
Checkout = () => import('@/views/Checkout.vue')
Loading = () => import('@/views/Loading.vue')
Place = () => import('@/views/Place.vue')
ThankYou = () => import('@/views/Thankyou.vue')
Failure = () => import('@/views/Failure.vue')
MenuDisplay = () => import('@/views/Menudisplay.vue')
InstantWebsite = () => import('@/views/Website.vue')

Vue.use VueRouter

export default new VueRouter(
  hash: false,
  mode: 'history',
  routes: [
    { path: '/', name: '', component: Order, children: [
        { path: '/Kiosk', name: 'Kiosk', component: Kiosk }
        { path: '/Register', name: 'Register', component: Register }
        { path: '/Address', name: 'Address', component: Address }
        { path: '/Closed', name: 'Closed', component: Closed }
        { path: '/Menu', name: 'Menu', component: Menu }
        { path: '/Checkout', name: 'Checkout', component: Checkout }
        { path: '/Loading', name: 'Loading', component: Loading }
        { path: '/Place', name: 'Place', component: Place }
        { path: '/Thankyou', name: 'ThankYou', component: ThankYou }
        { path: '/Failure', name: 'Failure', component: Failure }
        { path: '/MenuDisplay', name: 'MenuDisplay', component: MenuDisplay }
        { path: '/InstantWebsite', name: 'InstantWebsite', component: InstantWebsite }
        { path: '*', name: 'Start', component: Start }
      ]
    }
  ]
)
